import React, { type FC, useEffect, useRef } from 'react';

import classNames from 'classnames';

import styles from './slider.module.css';

type Props = {
  className?: string;
  min?: number;
  max?: number;
  step?: number;
  value?: number;
  showPercentage?: boolean;
  onChange?: (value: number) => void;
};

const Slider: FC<Props> = ({
  className,
  min,
  max,
  step,
  value,
  onChange,
  showPercentage,
}) => {
  const sliderRef = useRef<HTMLInputElement>(null);
  const [percentage, setPercentage] = React.useState(0);
  useEffect(() => {
    if (
      !sliderRef.current ||
      max === undefined ||
      min === undefined ||
      max === min
    ) {
      return;
    }

    const val = Number(value);
    const size = Math.ceil(((val - min) * 100) / (max - min));
    if (showPercentage) {
      setPercentage(size);
    }
    sliderRef.current.style.backgroundSize = `${size}% 100%`;
  }, [min, max, value, showPercentage]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(Number(event.target.value));
  };
  const SliderInput = (
    <input
      ref={sliderRef}
      className={classNames(className, styles.slider)}
      type="range"
      min={min}
      max={max}
      step={step}
      value={value}
      onChange={handleInputChange}
    />
  );

  if (!showPercentage) {
    return SliderInput;
  }
  return (
    <div className={styles.slider_wrapper}>
      {SliderInput}
      <div className={styles.slider_percentage}>{`${percentage}%`}</div>
    </div>
  );
};

export default Slider;
